// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"067c058a","273":"4340b9b8","295":"b8fb6deb","798":"903f93c7"}[chunkId] + ".chunk.js";
};